import React, { useState, useRef, useEffect } from "react";
import {
    ChevronDown,
    ChevronUp,
    Edit,
    Trash
} from "lucide-react";
import { useSidebar } from '../../SidebarContext';
import ReactQuill from "react-quill-new";
import "quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";


const AccordionItem = ({ item, isOpen, onToggle }) => {
    const itemRef = useRef(null);

    useEffect(() => {
        if (isOpen && itemRef.current) {
            itemRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    }, [isOpen]);
    return (
        <div ref={itemRef}
            className="w-full border-b border-gray-200 py-2 transition-all duration-300 ease-in-out">
            {/* Header */}
            <div
                onClick={onToggle}
                className="flex items-center justify-between cursor-pointer hover:bg-gray-50 p-2 rounded-lg"
            >
                <div className="flex items-center gap-4">
                    <img
                        src={item.thumbnail}
                        alt="thumb"
                        className="w-14 h-14 rounded-lg object-cover shadow-sm border border-gray-300"
                    />

                    <div>
                        <p className="font-semibold text-gray-900 text-sm lg:text-base">{item.title}</p>
                        <p className="text-xs text-gray-500">
                            {item.date} • {item.time} • <span className="text-red-400 hover:text-red-600 transition-colors">Delete</span>
                        </p>
                    </div>
                </div>

                <div className="flex items-center gap-3">
                    <button className="p-1 rounded">
                        {isOpen ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
                    </button>
                </div>
            </div>

            {/* Content */}
            <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`}>
                <div className="mt-2 p-3 space-y-4">

                    {/* Title */}
                    <div className="grid gap-2">
                        <label className="text-xs font-semibold text-gray-700 tracking-wide">Title</label>
                        <input
                            type="text"
                            defaultValue={item.title}
                            placeholder="Enter product title"
                            className="border border-gray-200 p-3 rounded-lg text-sm focus:ring-1 focus:ring-black focus:border-black transition-all shadow-sm outline-0"
                        />
                    </div>

                    {/* Short Description */}
                    <div className="grid gap-2 ">
                        <label className="text-xs font-semibold text-gray-700 tracking-wide">Short Description</label>
                        <ReactQuill
                            theme="snow"
                            placeholder="A quick overview of the product"
                            className="bg-white rounded-lg text-sm mb-10"
                        />
                    </div>

                    {/* Long Description */}
                    <div className="grid gap-2">
                        <label className="text-xs font-semibold text-gray-700 tracking-wide">Long Description</label>
                        <ReactQuill
                            theme="snow"
                            placeholder="Detailed product description"
                            className="bg-white rounded-lg text-sm mb-10"
                        />
                    </div>

                    {/* Key Features */}
                    <div className="grid gap-2">
                        <label className="text-xs font-semibold text-gray-700 tracking-wide">Key Features</label>
                        <textarea
                            rows={2}
                            placeholder="Feature 1, Feature 2, ..."
                            className="border border-gray-200 p-3 rounded-lg text-sm focus:ring-1 focus:ring-black focus:border-black transition-all shadow-sm outline-0"
                        ></textarea>
                    </div>

                    {/* Specification */}
                    <div className="grid gap-2">
                        <label className="text-xs font-semibold text-gray-700 tracking-wide">Specification</label>
                        <textarea
                            rows={2}
                            placeholder="Size, Color, Material, etc."
                            className="border border-gray-200 p-3 rounded-lg text-sm focus:ring-1 focus:ring-black focus:border-black transition-all shadow-sm outline-0"
                        ></textarea>
                    </div>

                    {/* Price */}
                    <div className="grid gap-2">
                        <label className="text-xs font-semibold text-gray-700 tracking-wide">Price</label>
                        <input
                            type="number"
                            placeholder="0.00"
                            className="border border-gray-200 p-3 rounded-lg text-sm focus:ring-1 focus:ring-black focus:border-black transition-all shadow-sm outline-0"
                        />
                    </div>

                    <button className="bg-gradient-to-bl from-blue-500 to-blue-700 text-white font-bold px-8 py-2.5 text-sm rounded-lg mt-4 hover:bg-gray-900 transition-all shadow-md">
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default function ProductHistory() {
    
    const [openId, setOpenId] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate()

     const handleNavigate = (url) => {
        navigate(url)
    };

    const items = [
        { id: 1, title: "Wireless Bluetooth Headphones", thumbnail: "https://via.placeholder.com/60", date: "2025-11-03", time: "10:25 AM" },
        { id: 2, title: "Smart LED Desk Lamp", thumbnail: "https://via.placeholder.com/60", date: "2025-10-28", time: "04:10 PM" },
        { id: 3, title: "Portable Power Bank 10000mAh", thumbnail: "https://via.placeholder.com/60", date: "2025-09-15", time: "09:50 AM" },
        { id: 4, title: "Ergonomic Wireless Mouse", thumbnail: "https://via.placeholder.com/60", date: "2025-08-09", time: "12:30 PM" },
        { id: 5, title: "4K Action Camera", thumbnail: "https://via.placeholder.com/60", date: "2025-07-22", time: "07:45 PM" }
    ];

    return (
        <>
            {/* Header */}
            <div className="flex items-center justify-between">
                <h1 className="dashboard-title">Generated History</h1>
                {/* Add Offers Button */}
                <div className="property-dropdown-wrapper">
                    <button className="oms-add-btn"
                        onClick={() => setIsOpen(!isOpen)}
                    // onClick={() => handleNavigate('/variable-product')}
                    >
                        Add Products
                    </button>
                    {isOpen && (
                        <ul className="property-dropdown-menu">
                            <li onClick={() => handleNavigate('/simple-product')}>
                                Simple Product
                            </li>
                            <li onClick={() => handleNavigate('/grouped-product')}>
                                Grouped Product
                            </li>

                            {/* <li onClick={() => handleNavigate('/external-affiliate-product')}>
                                    Affiliate Product
                                </li> */}
                            <li onClick={() => handleNavigate('/variable-product')}>
                                Variable Product
                            </li>
                        </ul>
                    )}
                </div>
            </div>

            <div className="w-full">
                {items.map(item => (
                    <AccordionItem
                        key={item.id}
                        item={item}
                        isOpen={openId === item.id}
                        onToggle={() =>
                            setOpenId(prev => prev === item.id ? null : item.id)
                        }
                    />
                ))}
            </div>
        </>
    );
}
